import { Features } from '@news-mono/web-common'
import { layout } from '../../App.routing'
import {
    CardExtensionProps,
    Extensions,
    returnEightCardExtensionProps,
    returnFourCardExtensionProps,
    returnOverrideCardProps,
    returnSevenCardExtensionProps,
} from './get-themed-segments-helpers'

type curations = 'afl-grand-final' | 'queens-legacy' | 'commonwealth-games'
export type themeOverrides =
    | 'grand-final'
    | 'grand-final-freo'
    | 'queens-legacy'
    | 'commonwealth-games'
export type layouts = '4-card' | '8-card' | '7-card'

interface cardLayoutProps {
    featureToggle: Features
    curation: curations
    themeOverride: themeOverrides
    hideHeadingLink?: boolean
    cardExtensionProps?: Extensions
}

const fourCardLayout = ({
    featureToggle,
    curation,
    themeOverride,
    cardExtensionProps,
}: cardLayoutProps) => {
    const extensions = returnFourCardExtensionProps(cardExtensionProps)

    return layout.nestedComposition({
        type: 'thor',
        feature: featureToggle,
        props: {
            ...returnOverrideCardProps(
                '4-card',
                'thor',
                curation,
                themeOverride,
                extensions.thorProps,
            ),
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'lima',
                    props: {
                        ...returnOverrideCardProps(
                            '4-card',
                            'lima',
                            curation,
                            themeOverride,
                            extensions.limaProps,
                        ),
                    },
                }),
            ],
        },
    })
}

const sevenCardLayout = ({
    featureToggle,
    curation,
    themeOverride,
    cardExtensionProps,
}: cardLayoutProps) => {
    const props = returnSevenCardExtensionProps(cardExtensionProps)

    return layout.nestedComposition({
        type: 'thor',
        feature: featureToggle,
        props: {
            ...returnOverrideCardProps(
                '7-card',
                'thor',
                curation,
                themeOverride,
                props.thorProps,
            ),
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'sierra',
                    props: {
                        ...returnOverrideCardProps(
                            '7-card',
                            'sierra',
                            curation,
                            themeOverride,
                            props.sierraProps,
                        ),
                    },
                }),
                layout.component({
                    type: 'lima',
                    props: {
                        ...returnOverrideCardProps(
                            '7-card',
                            'lima',
                            curation,
                            themeOverride,
                            props.limaProps,
                        ),
                    },
                }),
            ],
        },
    })
}

const eightCardLayout = ({
    featureToggle,
    curation,
    themeOverride,
    cardExtensionProps,
}: cardLayoutProps) => {
    const cardProps = returnEightCardExtensionProps(cardExtensionProps)

    return layout.nestedComposition({
        type: 'thor',
        feature: featureToggle,
        props: {
            ...returnOverrideCardProps(
                '8-card',
                'thor',
                curation,
                themeOverride,
                cardProps.thorProps,
            ),
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'sierra',
                    props: {
                        ...returnOverrideCardProps(
                            '8-card',
                            'sierra',
                            curation,
                            themeOverride,
                            cardProps.sierraProps,
                        ),
                    },
                }),
                layout.nestedComposition({
                    type: 'thor',
                    props: {
                        hasBackgroundFill: false,
                        containerWidth: '100%',
                        verticalGutters: false,
                        horizontalGutters: false,
                    },
                    contentAreas: {
                        main: [
                            layout.nestedComposition({
                                type: 'janus',
                                props: {
                                    ...returnOverrideCardProps(
                                        '8-card',
                                        'janus',
                                        curation,
                                        themeOverride,
                                        cardProps.janusProps,
                                    ),
                                },
                                contentAreas: {
                                    left: [
                                        layout.component({
                                            type: 'lima',
                                            props: {
                                                ...returnOverrideCardProps(
                                                    '8-card',
                                                    'lima-left',
                                                    curation,
                                                    themeOverride,
                                                    cardProps.leftLimaProps,
                                                ),
                                            },
                                        }),
                                    ],
                                    right: [
                                        layout.component({
                                            type: 'lima',
                                            props: {
                                                ...returnOverrideCardProps(
                                                    '8-card',
                                                    'lima-right',
                                                    curation,
                                                    themeOverride,
                                                    cardProps.rightLimaProps,
                                                ),
                                            },
                                        }),
                                    ],
                                },
                            }),
                        ],
                    },
                }),
            ],
        },
    })
}

export function getThemedSegment(props: {
    featureToggle: Features
    layoutVersion: layouts
    curation: curations
    themeOverride: themeOverrides
    cardExtensionProps?: CardExtensionProps
}) {
    if (props.layoutVersion === '4-card') {
        return fourCardLayout({
            featureToggle: props.featureToggle,
            curation: props.curation,
            themeOverride: props.themeOverride,
            cardExtensionProps: props.cardExtensionProps?.fourCardExtension,
        })
    } else if (props.layoutVersion === '7-card') {
        return sevenCardLayout({
            featureToggle: props.featureToggle,
            curation: props.curation,
            themeOverride: props.themeOverride,
            cardExtensionProps: props.cardExtensionProps?.sevenCardExtension,
        })
    }
    return eightCardLayout({
        featureToggle: props.featureToggle,
        curation: props.curation,
        themeOverride: props.themeOverride,
        cardExtensionProps: props.cardExtensionProps?.eightCardExtension,
    })
}
